<template>
  <div class="not-found-wrap">
    <img :src="require('../../styles/common/img/' + imgPath + '.png')" alt="" />
    <div>{{ tip }}</div>
    <a v-if="buttonText" href="javascript:void(0)" class="not-found-btn" @click="notFoundEvt">{{ buttonText }}</a>
  </div>
</template>

<script>
export default {
  name: 'FtNotFound',
  props: {
    // 提示图片
    imgPath: {
      default() {
        return 'not_found_record';
      }
    },
    tip: {
      default() {
        return '';
      }
    },
    buttonText: {
      default() {
        return '';
      }
    },
    actionFn: {
      type: Function,
      default() {
        return () => {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    notFoundEvt() {
      // 点击按钮的回调
      this.$emit('actionFn');
    }
  }
};
</script>

<style lang="scss" scoped>
.not-found-wrap {
  text-align: center;
  font-size: 0.65rem;
  color: #8da7c5;
  padding-top: 2.5rem;
  box-shadow: inset 0 0.5rem 0.5rem -0.2rem #eeeeee;
  img {
    width: 10.05rem;
    margin: 3rem auto 0.5rem;
  }
  .not-found-btn {
    display: block;
    width: 9.025rem;
    height: 2rem;
    text-align: center;
    line-height: 2rem;
    color: #fff;
    background: #44aff3;
    font-size: 0.8rem;
    margin: 2rem auto 0;
    border-radius: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// ftNotFound.vue